class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    const searchLimit = this.input.dataset.limit;
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm,searchLimit);
  }
  getSearchResults(searchTerm,searchLimit) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=vendor,product_type,tag,body`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
      if(document.getElementById('SearchValueMobile')){
        document.getElementById('SearchValueMobile').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    $('#predictive-search-results').css('max-height',$(window).height());
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
     $('#predictive-search-results').css('max-height','auto');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
// document.querySelector('.overlay-box').addEventListener('click',function(e){
//   document.querySelector('body').classList.remove('open-menu');
// });
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                console.log('data',data.items);
                
                if(data.items.length > 0 && data.items[0].final_price != undefined){
                  var option_price = Shopify.formatMoney(data.items[0].final_price); 
                  data.items[0].options_with_values.forEach(function (option) {
                    if(option.name == "Color") {
                      option_color = option.value;
                    }
                    if(option.name == "Size") {
                      option_size = option.value; 
                    }
                  });
                   var pro_title = data.items[0].product_title.split("|")[0].split("-")[0];
                  document.querySelector("#cart-notification-product").innerHTML = "";        
                  document.querySelector("#cart-notification-product").innerHTML = 
                  `<div class="main_notification row">
                    <div class="lef_notification">
                      <img src="${data.items[0].featured_image.url}" alt="${data.items[0].featured_image.alt}">
                    </div>
                    <div class="center_notification">
                      <div>
                      <p>${pro_title}</p>
                      <div class="pro_var mt-6">
                        <div class="singal_var">${option_size} / ${option_color}</div>
                      </div>
                    </div>
                    <div class="right_notification">
                      <div class="cart-price">${option_price}</div>
                    </div>
                  </div>`;
                }
                
                load_cart();
                setTimeout(() => {
                  $('.main_cart_notification').addClass('active');
                }, "1500")
                setTimeout(() => {
                  $('.main_cart_notification.active').removeClass('active');
                }, "5000")
                setTimeout(function(e){
                  // document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = '(' + cart_count + ')';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = cart_count;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.add('active');
      }else{
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = '(0)';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = 0;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.remove('active');
      }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
if(document.querySelector('.mobile-nav .nav-wrap')){
  document.querySelectorAll('.mobile-nav .nav-wrap a').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
      document.querySelector('.snippet-menu-drawer').scrollTop = 0
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};





























